var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSundial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3 0C2.166 0 1.458.292.875.875A2.894 2.894 0 0 0 0 3.001v2c0 .832.292 1.54.875 2.124A2.888 2.888 0 0 0 3 8c0 3.75.645 7.27 1.937 10.563 1.292 3.29 3.084 6.104 5.375 8.437 2.292 2.333 4.896 4 7.813 5-4.417 1.5-8.041 4.48-10.876 8.937C4.417 45.397 3 50.417 3 56c-.833 0-1.54.292-2.124.875A2.893 2.893 0 0 0 0 59v2c0 .833.292 1.543.875 2.125A2.892 2.892 0 0 0 3 64h42c.833 0 1.542-.292 2.125-.875A2.892 2.892 0 0 0 48 61v-2c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 45 56c0-5.584-1.417-10.604-4.25-15.063C37.916 36.48 34.292 33.5 29.875 32c4.417-1.5 8.041-4.48 10.875-8.937C43.583 18.603 45 13.583 45 8a2.89 2.89 0 0 0 2.125-.875A2.895 2.895 0 0 0 48 5V3c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 45 0H3zm11.812 20.688C12.271 17.147 11.001 12.917 11.001 8h26c0 4.917-1.272 9.147-3.813 12.688C30.645 24.229 27.583 26 24 26c-3.584 0-6.646-1.77-9.188-5.312zm0 22.624C17.354 39.771 20.416 38 24 38c3.583 0 6.625 1.792 9.125 5.375C35.708 46.875 37 51.083 37 56H11c0-4.917 1.27-9.146 3.812-12.688z",
    id: "7hcy35v1da"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 8)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 56H11c0-4.917 1.271-9.146 3.812-12.688C17.354 39.771 20.417 38 24 38s6.625 1.792 9.125 5.375C35.708 46.875 37 51.083 37 56",
    fill: "#DFECF1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "xz6tetnucb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7hcy35v1da"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B0C5CC",
    mask: "url(#xz6tetnucb)",
    d: "M-4.571 68.571H52.57V-4.57H-4.57z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSundial);
export default __webpack_public_path__ + "static/media/sundial.f4d07bf2fe010ea1a13dc5cbac2b734c.svg";
export { ForwardRef as ReactComponent };